import { useOutsideClick } from 'src/hooks/useOutsideClick'
import styles from './index.module.scss'

interface IDropDownProps {
  visibleContent: React.ReactElement | string | any
  hiddenContent: React.ReactElement | string
  centered?: boolean
  lefted?: boolean
  righted?: boolean
  closeOnClick?: boolean
  isAbsoluteBottom?: boolean
}

export function Dropdown({
  visibleContent,
  hiddenContent,
  centered = false,
  lefted = false,
  righted = true,
  closeOnClick = false,
  isAbsoluteBottom = false,
}: IDropDownProps) {
  const { changedBlockRef, isBlockActive, setIsBlockActive } = useOutsideClick(false)

  const toggleSelect = (event) => {
    event.preventDefault()
    event?.stopPropagation()
    setIsBlockActive(!isBlockActive)
  }

  const closeOnClickHandler = (event) => {
    event.preventDefault()
    event?.stopPropagation()

    if (closeOnClick) {
      setIsBlockActive(false)
    }
  }

  return (
    // eslint-disable-next-line
    <div ref={changedBlockRef} className={styles.container}>
      {/* eslint-disable-next-line */}
      <div className={`${styles.visible}`} onClick={toggleSelect}>
        {visibleContent}
      </div>
      {isBlockActive && (
        // eslint-disable-next-line
        <div
          className={`${styles.hidden} ${righted ? styles.righted : ''} ${centered ? styles.centered : ''} ${
            lefted ? styles.lefted : ''
          } ${isAbsoluteBottom ? styles.isAbsoluteBottom : ''}`}
          onClick={closeOnClickHandler}
        >
          {hiddenContent}
        </div>
      )}
    </div>
  )
}

interface IDropDownProps {
  visibleContent: React.ReactElement | string | any
  hiddenContent: React.ReactElement | string
  centered?: boolean
  lefted?: boolean
  righted?: boolean
  closeOnClick?: boolean
  isAbsoluteBottom?: boolean
}

export function DropdownSimple({ visibleContent, hiddenContent, closeOnClick = false }: IDropDownProps) {
  const { isBlockActive, setIsBlockActive } = useOutsideClick(false)

  const toggleSelect = (event) => {
    event.preventDefault()
    event.stopPropagation()
    setIsBlockActive(!isBlockActive)
  }

  const closeOnClickHandler = (event) => {
    event.preventDefault()
    event.stopPropagation()

    if (closeOnClick) {
      setIsBlockActive(false)
    }
  }

  return (
    <div className={styles.containerStatic}>
      {/* eslint-disable-next-line */}
      <div className={`${styles.visible}`} onClick={toggleSelect}>
        {visibleContent}
      </div>
      {isBlockActive && (
        // eslint-disable-next-line
        <div className={`${styles.hiddenStatic}`} onClick={closeOnClickHandler}>
          {hiddenContent}
        </div>
      )}
    </div>
  )
}
